import { Pipe, PipeTransform } from '@angular/core';

//Simple generic pipe to pass in callback filters to ngFor
@Pipe({
  name: 'callback',
  standalone: false
})
export class CallbackPipe implements PipeTransform {

  transform <T>(items: T[], callback: (item: T) => boolean):  T[] {
    if (!items || !callback) {
      return items;
    }
    return items.filter(item => callback(item));
  }
}
